import { get, put } from './api';

export interface DonorProfile {
  id?: string;
  openId: string;
  name: string;
  phone: string;
  nickname?: string;
  avatar?: string;
  status?: 'ACTIVE' | 'DEACTIVATED'; // 用户状态
  createTime?: string;
  updateTime?: string;
}

export interface UpdateDonorProfileRequest {
  openId: string;
  name: string;
  phone: string;
}

export class DonorProfileService {
  /**
   * 获取用户信息
   * @param openId 微信 OpenID
   */
  static async getProfile(openId: string): Promise<DonorProfile | null> {
    try {
      const response = await get<DonorProfile>('/donor/profile', { openId });
      // 如果返回空对象，表示用户不存在
      if (!response || (!response.name && !response.phone)) {
        return null;
      }
      return response;
    } catch (error) {
      console.error('[DonorProfileService] Failed to get profile:', error);
      return null;
    }
  }

  /**
   * 更新用户信息
   * @param openId 微信 OpenID
   * @param name 姓名
   * @param phone 手机号
   */
  static async updateProfile(openId: string, name: string, phone: string): Promise<DonorProfile> {
    return put<DonorProfile>('/donor/profile', {
      openId,
      name,
      phone,
    });
  }

  /**
   * 注销用户账号（假注销）
   * @param openId 微信 OpenID
   */
  static async deactivateAccount(openId: string): Promise<void> {
    return put<void>('/donor/profile/deactivate', {
      openId,
    });
  }
}

